export const RETURN_POLICY_SUBTEXT = `You are eligible for one free return per order. $15 will be deducted from your refund for each subsequent return.`
